"use strict";

exports.__esModule = true;
var _NavbarTitle = require("./NavbarTitle");
Object.keys(_NavbarTitle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NavbarTitle[key]) return;
  exports[key] = _NavbarTitle[key];
});